export const HOST = 'http://localhost:3000/';

export const CURRENT_LANGUAGE = 1;
export const TIME_ALWAYS_VISIBLE = 2;
export const CALL_KEY_MAX_LENGHT = 40;
export const STR_SOFTPHONE = 'softphone';
export const SM_QUEUE_SERVER = 'server';

export const SOFTPHONES_DEFAULT = {
	4: 'WebRTC',
};

export const SOFTPHONES_KEY = {
	WEBRTC: 4,
};

export const SOFTPHONES = {
	4: 'WEBRTC',
};

export const HANG_UP_SUBACTIONS = {
	MANUAL_CALL: 'ManualCall',
	FISRT_CALL: 'FirstCall',
	CALL: 'Call', 
	LEAVE_MESSAGE: 'LeaveMessage'
};

export const USER_ACTIONS = {
	NONE: 'NONE_USER_ACTION',
	LOGIN: 'LOGIN_UA',
	CHANGE_LANGUAGE: 'CHANGE_LANGUAGE_UA',
	LOGOUT: 'LOGOUT',
	SHOW_PSW_RESET: 'SHOW_PSW_RESET'
};

export const USER_STATE = {
	CHANGE_STATE: 'CHANGE_STATE',
	CALL_OUT: 'CALL_OUT',
	LOGED_OUT: 'LOGED_OUT',
	LOGED_IN: 'LOGED_IN',
	AGENT_READY: 'AGENT_READY',
	NO_AVAILABLE: 'NO_AVAILABLE',
	DIALOG: 'DIALOG',
	MANUAL_CALL: 'MANUAL_CALL',
	WAITING_TRANSFER: 'WAITING_TRANSFER',
	ERROR: 'ERROR',
	CALL_TRANSFER: 'CALL_TRANSFER',
	RINGING: 'RINGING',
	WRAPUP: 'WRAPUP',
	XFER: 'XFER',
	OTHER: 'OTHER',
	EXCLUSIVE_CALLBACK: 'EXCLUSIVE_CALLBACK',
	CHATTING: 'CHATTING',
	READY_PREVIEW: 'READY_PREVIEW',
	ASSISTED: 'ASSISTED',
	DIALOG_WHATSAPP: 'DIALOG_WHATSAPP',
	WHATSAPP: 'WHATSAPP',
	AGENT_PREVIEW: 'AGENT_PREVIEW',
	INACTIVE: 'INACTIVE',
	DIALOG_EMAIL: 'DIALOG_EMAIL'
};

export const PREVIEW_TRANSFER_SUBACTION = {
	TRANSFER_REQUEST: 'RequestAgent',
	TRANSFER_RESPONSE: 'AnswerAgentTransfer'
}

export const ASSISTED_TRANSFER_SUBACTION ={
	ASSISTED: 'assistedCallTransfer',
	PREVIEW: 'TransferPreviewCall'
}

export const ASSISTED_TRANSFER = {
	CHANGE_STATE: 'ASSISTED_TRANSFER_CHANGE_STATE',
	SECOND_CALL_CONNECTED: 'SECOND_CALL_CONNECTED',
	ON_STATUS: 'ON_STATUS',
	SECOND_CALL_HANG_UP: 'SECOND_CALL_HANG_UP',
	CONFERENCE_CALL_CONNECTED: 'CONFERENCE_CALL_CONNECTED',
	CONFERENCE_CALL_HANG_UP: 'CONFERENCE_CALL_HANG_UP',
	NEW_SECOND_CALL_SET: 'NEW_SECOND_CALL_SET',
	MAIN_CALL: 'MAIN_CALL',
	ON_CONFERENCE: 'ON_CONFERENCE',
	ON_CONFERENCE_CALL: 'ON_CONFERENCE_CALL',
	TRANSFERRING: 'TRANSFERRING',
	IDDLE_END: 'IDDLE_END'

};

export const BLIND_TRANSFER ={
	BLIND_TRANSFER_HANG_UP: 'BLIND_TRANSFER_HANG_UP',
}

export const PREVIEW_TRANSFER = {
	DATA_CALL_PREVIEW: "DATA_CALL_PREVIEW",
	ON_RESPONSE_TRANSFER: "ON_RESPONSE_TRANSFER",
	SHOW_ALERT: "SHOW_ALERT",
	SHOW_PREVIEW_DATA: "SHOW_PREVIEW_DATA",
	SET_AGENT_LIST: "SET_AGENT_LIST"
}

export const VALIDATING_TELEPHONY = {
	SOURCE_MICRO: 'SOURCE_MICRO',
	VALIDATING: 'VALIDATING_TELEPHONY',
	VALID: 'VALID_TELEPHONY',
	ERROR: 'ERROR_TELEPHONY'
};

export const CALL_ACTIONS = {
	DATA_CALL: 'DATA_CALL',
	EXTRA_DATA_CALL: 'EXTRA_DATA_CALL'
};

export const ACTION_CALL_ACD = {
	MUTE: 'MUTE',
	HOLD: 'HOLD',
	DTMF: 'DTMF'
};

export const VOLUME = {
	SPEAKER: 'SPEAKER_VOLUME',
	MICROPHONE: 'MICROPHONE_VOLUME'
};


export const API_ENDPOINTS = {
	HOLD: 'Hold',
	SAVE_DISPOSITION: 'SaveDispositionListACD',
	CALL_OUT_CAMPAIGNS: 'CallOutCampaigns',
	CALL_BACK: 'InsertCallBack',
	TRANSFER_CALL_PREVIEW: 'TransferCallData',
	UPDATE_CALL_KEY: 'UpdateCallKey',
	SELECT_ANI_MANUAL_CALL: 'SelectAniManualCall'
};


export const TYPE_CALL = {
	INBOUND: 1,
	OUTBOUND: 2
};

export const LANGUAGE = {
	0: 'es',
	1: 'en',
	2: 'pt'
}


export const CAMP_TYPES = {
	IN: 0,
	OUT: 1
}

export const LIST_STATES = {
    ALERT: 'ALERT',
    ASSISTED: 'Assisted',
    AUXILIAR_READYS : 'Auxiliary',
    CALLOUT: 'Callout',
    DIALOG: 'Dialog',
    FIRSTCALL: 'firstCall',
    LOGIN: 'Login',
    LOGOUT: 'logout',
    NOTREADY: 'NotReady',
    OTHER: 'Other',
    PROBLEM: 'Problem',
    READY: 'Ready',
    RINGING: 'Ringing',
    VALIDATE_TELEPHONY: 'OnValidatedTelephony',
    WRAPUP: 'Wrapup',
    XFER: 'Xfer',
}

export const TYPE_TRANSFER = {
	SWTICH : -1,
	DIRECTORY_OR_EXTERNAL_NUMBER : 0,
    AGENT : 1,
    INBOUND_CAMP : 2,
}

export const REFERENCES_TRANSFER = {
	DIAL : "dial",
	SWTICH_MAIN_CALL: "main",
	SWTICH_SECOND_CALL: "second",
	CREATE_CONFERENCE: "conference",
	TRANSFER_CALL: "transfer",
	LEAVE_CONFERENCE: "leave",
	HANGUP_SECOND_CALL: "hangup",
};

export const BLOCKED_SETTING_TRANSFER = {
	ALL: 82,
	ASSISTED: 76,
};

export const STEP_MANUAL_CALL = {
	FIRST_TRY: 0,
	BLACKLIST_OR_WRONG_CAMP: 2,
	INCORRECT_NUMBER: 3
};
export const CALL_MODE = {
	MANUAL_CALL: 0,
	ASSISTED_CALL: 2
}
export const ALERT_CATALOG = {
	NO_CAMPAIGNS: 1090,
	CHECK_NUMBER: 1091,
	INCORRECT_NUMBER: 1092,
	TIME_ZONE: 1095
};

export const ERROR_CATALOG = {
	UNABLE_VERIFY_PHONE_NUMBER: 1081,
	ON_BLACKLIST: 1090,
	NO_CELLPHONE: 1091,
	NO_LONG_DISTANCE: 1092,
	NO_LOCAL_CALLS: 1093,
    USER_OUT_CAMP: 1094,
    NO_PORTS_ASSIGNED: 1098,
	NO_CAMPAIGN: 1099,
	NO_CAMPAIGN_FOUND: 1083,
	NO_DATA_FIELD: 1084
};

export const SHOW_TRANSFERS_BUTTONS_DEFAULT = {
	DISPOSITION : true,
	TRANSFER : true,
	DTMF: true, 
	VOLUME: true, 
	MUTE: true, 
	HOLD: true, 
	MARKS: true, 
	IVR: true, 
	RECORD: true,
	DATACALL: true
}

export const SHOW_TRANSFERS_BUTTONS = {
	DISPOSITION : false,
	TRANSFER : false,
	DTMF: false, 
	VOLUME: true,
	MUTE: true, 
	HOLD: false, 
	MARKS: false, 
	IVR: false, 
	RECORD: false,
	DATACALL: false
}

export const SHOW_TRANSFERS_BUTTONS_REFERENCE = {
	DISPOSITION : 'DISPOSITION',
	TRANSFER : 'TRANSFER',
	DTMF: 'DTMF', 
	VOLUME: 'VOLUME',
	MUTE: 'MUTE', 
	HOLD: 'HOLD', 
	MARKS: 'MARKS', 
	IVR: 'IVR', 
	RECORD: 'RECORD',
	DATACALL: 'DATACALL'
}

export const STATE_TO_PLAY_END_AUDIO= {
	HANG_UP_CLIENT: 1,
	HANG_UP_AGENT: 2
};

export const MESSAGE_CODES_ALERT = 
{
	BUSY: '1500',
    FAX: '1502',
}
export const MESSAGE_CODES_AUDIOS = 
{
	BUSY: 'busy',
    FAX: 'fax',
}

export const ERROR_CATALOG_LIST = {
    [ERROR_CATALOG.UNABLE_VERIFY_PHONE_NUMBER]: {code: 10900, description:"You must select a campaign or number is invalid."},
    [ERROR_CATALOG.ON_BLACKLIST]: {code: 10901, description:"The telephone number cannot be dialed because it is in a Do Not Call List"},
    [ERROR_CATALOG.NO_CELLPHONE]: {code: 10902, description:"You are not authorized to call cell phones"},
    [ERROR_CATALOG.NO_LONG_DISTANCE]:{code: 10903, description:"You are not authorized to make long distance calls"},
    [ERROR_CATALOG.NO_LOCAL_CALLS]: {code: 10904, description:"You are not authorized to make local calls"},
    [ERROR_CATALOG.USER_OUT_CAMP]: {code: 10905, description:"You are not assigned to the campaign. Please select another one and try again"},
    [ERROR_CATALOG.NO_PORTS_ASSIGNED]: {code: 10906, description:"Cannot complete call. There are no ports assigned to the campaign. Contact the system administrator."},
    [ERROR_CATALOG.NO_CAMPAIGN]: {code: 10907, description:"Unable to complete the call. Access to this campaign was disabled"},
    [ERROR_CATALOG.NO_CAMPAIGN_FOUND]: {code: 10908, description:"Unable to make manual calls; there are no assigned campaigns"},
    [ERROR_CATALOG.NO_DATA_FIELD]: {code: 10909, description:"Enter a value in the data field to make call"},
}

export const ALERT_CATALOG_LIST = {
    [ALERT_CATALOG.TIME_ZONE]: {code: 10950, description:"Unable to make the call because the campaign is off schedule"},
    [ALERT_CATALOG.NO_CAMPAIGNS]: {code: 10951, description:"There are no available campaigns to make the manual call."},
    [ALERT_CATALOG.CHECK_NUMBER]: {code: 10952, description:"The call might not be completed. The number does not match the standard length."},
    [ALERT_CATALOG.INCORRECT_NUMBER]:{code: 10952, description:"The number seems to be incomplete. Would you like to change it?"},
}

export const DISPOSITIONS_ACTIONS = {
    GET_DISPOSITIONS: 'getDispositions',
    GET_DISPOSITIONS_AND_NUMBERS: 'getDispositionsAndNumbers',
    EXIT_DISPOSITION_MODE: 'exitDispositionMode',
    GET_PHONE_NUMBERS: 'getPhoneNumbers'
}
export const UNAVAILABLES_ACTIONS = {
    GET_UNAVAILABLES: 'getUnavailables',
    SET_UNAVAILABLES: 'setUnavailables',
}
export const ALERT_DIAL_RESULT_LIST = {
	1500: 'Busy line',
	1501: 'No answer',
	1502: 'Fax/Modem',
	1503: 'AM detected',
	1504: 'No dialing tone',
	1505: 'Busy circuit',
	1506: 'Other',
	1507: 'Out of service',
	1508: 'The call cannot be completed',
	1509: 'Unavailable options are not enabled.',
	1510: 'No unavailable option has been selected yet.',
	1511: 'Cannot complete call. There are no available ports. Try again in 1 minute, while the dialing attempts in progress are completed.',
	}
